<div class="dialog-overlay">
    <div class="dialog-container">
        <form [formGroup]="formGroup">
            <div class="dialog-header">
                <span class="dialog-header__title">
                    {{ 'aumico_add_new_notes_accordion_section_title' | i18next }}
                </span>
                <span
                    hamIconShapes
                    icon="assets/hamIcons/x.svg"
                    [variant]="'transparent'"
                    [size]="'xs'"
                    class="add-notes-close-icon"
                    (click)="closeDialog()"
                >
                </span>
            </div>

            <div class="border-top-separator"></div>

            <div class="dialog-content">
                <div class="notes-title-input">
                    <div class="note-title">{{ 'aumico_add_new_notes_accordion_section_note_title' | i18next }}</div>
                    <div>
                        <textarea
                            hamInput
                            placeholder="{{
                                'aumico_add_new_notes_accordion_section_note_title_input_placeholder' | i18next
                            }}"
                            formControlName="title"
                        ></textarea>
                    </div>
                </div>

                <div class="text-above-cards">
                    {{ 'aumico_add_new_notes_accordion_section_select_note_component_to_add' | i18next }}
                </div>
                <div class="notes-cards-container">
                    <div
                        *ngFor="let component of notesComponents"
                        [ngClass]="{
                            'hidden-component': !component.shouldBeVisibleForUser && !supportOperation
                        }"
                    >
                        <div
                            *ngIf="component.shouldBeVisibleForUser || supportOperation"
                            [ngClass]="{
                                'notes-card': true,
                                selected: selectedNoteComponent === component.componentName
                            }"
                            (click)="onSelectComponent(component.componentName)"
                        >
                            <div class="notes-card-content">
                                <img [src]="component.imagePath" [alt]="component.componentType" />
                                <div class="notes-card__title">
                                    {{ component.title | i18next }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="showClipboard"
                        [ngClass]="{
                            'notes-card': true,
                            selected: pasteComponentSelected,
                            'background-highlight': true
                        }"
                        (click)="onPasteComponent()"
                    >
                        <div class="notes-card-content">
                            <img [src]="componentInClipboardImagePath" />
                            <div class="notes-card__title">
                                {{ 'aumico_add_new_notes_paste_from_clipboard' | i18next }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="border-top-separator footer"></div>
            <div class="dialog-footer">
                <ham-button
                    [size]="'sm'"
                    [disabled]="!isFormValid"
                    type="submit"
                    (click)="onAddNoteAccordion($event)"
                    stopPropagation
                    >{{ 'aumico_add_new_notes_accordion_section_button' | i18next }}</ham-button
                >
            </div>
        </form>
    </div>
</div>
